// src/com/user_alloc/UserAllocReuse.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
//import { styled } from '@mui/material/styles';
import { Button, DialogContent, DialogActions, Grid, CircularProgress } from '@mui/material';
import { AppObject, AppStyle, InputType } from '../../value/AppConst';
import VzmTextField from '../../common/VzmTextField';
import {  ErrorHintBox } from '../../common/VzmStyled';
import InputUtil from '../../value/InputUtil';
import IsValid from '../../value/IsValid';
import InformForgotPassword from '../user_info/InformForgotPassword';

const InputMap = {
    // toAdd, toEdit : mark if need to submit for mutation
    userId : {
        id: 'userId', label: '사용자ID',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        help: '25자 이내로 입력하세요.',
        check: (value) => {return IsValid.string(value, 0, 25)},
    },
    password : {
        id: 'password', label: '암호',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        help: '본인 확인을 위해 암호를 입력하세요.',
        check: (value) => {return IsValid.string(value, 8, 50)},
    }
};

/**
 * (USER_ALLOC) 정보 생성 또는 편집 Dialog의 내용 부분
 * 사용자 승인요청 > 사용중지 해제요청
 * 로그인 화면(AppLogin.js) 아래에 있는 버튼을 누르면 활성화 되는 화면 내에 들어감.
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2025-09-19 13:39:47 using DbdbTap
 * https://www.dbdbtap.com
 */
export default function UserAllocReuse({
    RequestTabs,
    onClose,
    onRequestSave,
    responseSaving, // Response if result is NOT OK.
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const {loading:loadingSave, error:errorSave, data:resultSave} = responseSaving; // 전송 결과에 대한 View 기능 소화.

    // const dcTypeCdOptions = ValueMisc.makeCodesToSelectList(codeTree, CodeGroup.DC_TYPE_CD, InputMap.dcTypeCd.id);


    const onChangeValue = (id, value, error) => {
        const newInput = InputUtil.reflectData(input, id, value, error, InputMap, false);
        setInput(newInput);
    };

    const onClickSubmit = () => {
        const param = {
            userId: input.data.userId,
            password: input.data.password,
        };
        onRequestSave(param);
    };

    const askCancel = async () => {
        const confirm = window.confirm("정말 취소하시겠습니까?");
        if(confirm) onClose();
    };

    const onClickCancel = () => {
        if(input.changed) askCancel();
        else onClose();
    };

    // Input field initiallized using getInputField(c,t,i)
    return(
        <>
            <DialogContent>
                {RequestTabs}
                <Box style={{minWidth: 600}}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <VzmTextField
                                dict={InputMap.userId}
                                value={input.data.userId}
                                onChange={onChangeValue}
                                fullWidth={true}
                            />
                        </Grid><Grid item xs={6}></Grid>
                        <Grid item xs={6}>
                            <VzmTextField
                                dict={InputMap.password}
                                value={input.data.password}
                                onChange={onChangeValue}
                                isPassword={true}
                                fullWidth={true}
                            />
                        </Grid><Grid item xs={6}></Grid>
                        <Grid item xs={12}>
                            <InformForgotPassword />
                        </Grid>
                    
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions style={{display:'flex'}}>
                {
                    input.errorLabels && input.errorLabels.length > 0
                    ?
                    <ErrorHintBox>
                        확인: {input.errorLabels.join(', ')}
                    </ErrorHintBox>
                    : null
                }
                {
                    loadingSave
                    ?
                    <span>
                        <CircularProgress />
                        &nbsp;데이터 저장 중...
                    </span>
                    :
                    <>
                        <Button
                            onClick={onClickSubmit}
                            disabled={
                                input.hasError || !input.changed
                                || loadingSave
                            }
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                        >요청</Button>
                        <Button onClick={onClickCancel}
                            color={AppStyle.mui.warning}
                            variant={AppStyle.mui.contained}
                        >취소</Button>
                    </>
                }
            </DialogActions>
        </>
    );
}
